import React from "react";

const Price = () => {
  return (
    <section className="price-cta">
      <h3 className="starter">Starting from</h3>
      <h3 className="money">$100</h3>
    </section>
  );
};

export default Price;
